<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="medium"
            @close="close"
			:hideFooter="true	"
			>
            <template slot="header">
                <h5 class="mb-0">{{ $t('Feature List on') }} {{data && data.name ? data.name : '' }}</h5>
            </template>
            <template slot="body">
				<!-- Loader -->
				<div class="p-5 text-center" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<!-- main List -->
				<div id="styleScroll2" class="list-group list-feature-wrapper">
					<div>
						<!-- display output -->
						<div @click="editItem('display_outputs', (displayOutputLimit + displayOutputAddLimit), displayOutputLimit)">
							<a class="list-group-item text-decoration-none pointer">
								<div class="d-flex justify-content-between">
									<h5>Display Output</h5>
									<div class="d-flex">
										<div @click="editItem('display_outputs', (displayOutputLimit + displayOutputAddLimit), displayOutputLimit)">
											<mdIcon class="feature-icon-edit" v-tooltip="'Edit'">edit</mdIcon>
										</div>
									</div>
								</div>
								<div v-if="displayOutputLimit + displayOutputAddLimit !== 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">{{ displayOutputLimit + displayOutputAddLimit }}</label>
								</div>
								<div v-if="displayOutputLimit + displayOutputAddLimit === 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">Unlimited</label>
								</div>
							</a>
						</div>
						<!-- assetsLimit -->
						<div @click="editItem('assets', (assetsLimit + assetsAddLimit), assetsLimit)">
							<a class="list-group-item text-decoration-none pointer">
								<div class="d-flex justify-content-between">
									<h5>Assets</h5>
									<div class="d-flex">
										<div @click="editItem('assets', (assetsLimit + assetsAddLimit), assetsLimit)">
											<mdIcon class="feature-icon-edit" v-tooltip="'Edit'">edit</mdIcon>
										</div>
									</div>
								</div>
								<div v-if="assetsLimit + assetsAddLimit !== 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">{{ assetsLimit + assetsAddLimit }}</label>
								</div>
								<div v-if="assetsLimit + assetsAddLimit === 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">Unlimited</label>
								</div>
							</a>
						</div>
						<!-- rundownsLimit -->
						<div @click="editItem('rundowns', (rundownsLimit + rundownsAddLimit), rundownsLimit)">
							<a class="list-group-item text-decoration-none pointer">
								<div class="d-flex justify-content-between">
									<h5>Rundowns</h5>
									<div class="d-flex">
										<div @click="editItem('rundowns', (rundownsLimit + rundownsAddLimit), rundownsLimit)">
											<mdIcon class="feature-icon-edit" v-tooltip="'Edit'">edit</mdIcon>
										</div>
									</div>
								</div>
								<div v-if="rundownsLimit + rundownsAddLimit !== 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">{{ rundownsLimit + rundownsAddLimit }}</label>
								</div>
								<div v-if="rundownsLimit + rundownsAddLimit === 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">Unlimited</label>
								</div>
							</a>
						</div>
						<!-- addingUserLimit -->
						<div @click="editItem('adding_user', (addingUserLimit + addingUserAddLimit), addingUserLimit)">
							<a class="list-group-item text-decoration-none pointer">
								<div class="d-flex justify-content-between">
									<h5>Adding User</h5>
									<div class="d-flex">
										<div @click="editItem('adding_user', (addingUserLimit + addingUserAddLimit), addingUserLimit)">
											<mdIcon class="feature-icon-edit" v-tooltip="'Edit'">edit</mdIcon>
										</div>
									</div>
								</div>
								<div v-if="addingUserLimit + addingUserAddLimit !== 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">{{ addingUserLimit + addingUserAddLimit }}</label>
								</div>
								<div v-if="addingUserLimit + addingUserAddLimit === 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">Unlimited</label>
								</div>
							</a>
						</div>
						<!-- storageLimit -->
						<div @click="editItem('storage', (storageLimit + storageAddLimit), storageLimit)">
							<a class="list-group-item text-decoration-none pointer">
								<div class="d-flex justify-content-between">
									<h5>Storage</h5>
									<div class="d-flex">
										<div @click="editItem('storage', (storageLimit + storageAddLimit), storageLimit)">
											<mdIcon class="feature-icon-edit" v-tooltip="'Edit'">edit</mdIcon>
										</div>
									</div>
								</div>
								<div v-if="storageLimit + storageAddLimit !== 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">{{ storageLimit + storageAddLimit }} Mb</label>
								</div>
								<div v-if="storageLimit + storageAddLimit === 0" >
									<label class="text-secondary">{{ $t('Limit') }}: </label><label class="mr-3 ml-1">Unlimited</label>
								</div>
							</a>
						</div>
					</div>
				</div>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
		<!-- Modals -->
		<div class="modals">
			<!-- Package Features Form -->
			<package-features-users-form
				:data="selected"
				@saved="insertItem"
				@close="closeModalFeature"
				v-if="isFeatureFormVisible"
			/>
		</div>
	</div>
</template>

<script>

import Modal from '@/components/Modal.vue';
import PackageFeaturesUsersForm from '@/components/PackageFeaturesUsersForm.vue';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'ModalPackageFeatureUsers',
	components: {
		Modal,
		PackageFeaturesUsersForm,
	},
	props: {
		data: {
			type: Object,
		},
	},
	mounted() {
	},
	data: () => ({
		selected: null,
		isFeatureFormVisible: false,
		isConfirmRemoveVisible: false,
		isFetching: false,
		displayOutputLimit: 0,
		assetsLimit: 0,
		rundownsLimit: 0,
		addingUserLimit: 0,
		storageLimit: 0,
		displayOutputAddLimit: 0,
		assetsAddLimit: 0,
		rundownsAddLimit: 0,
		addingUserAddLimit: 0,
		storageAddLimit: 0,
	}),
	methods: {
		initData() {
			if (this.data) {
				this.setData(this.data);
			}
		},
		setData(data) {
			const settings = JSON.parse(data.settings);
			if (settings) {
				const settingsString = data.settings;
				const settings = JSON.parse(settingsString);
				this.displayOutputLimit = settings && settings.subscription && settings.subscription.display_outputs && settings.subscription.display_outputs.limit ? duplicateVar(settings.subscription.display_outputs.limit) : 0;
				this.assetsLimit = settings && settings.subscription && settings.subscription.assets && settings.subscription.assets.limit ? duplicateVar(settings.subscription.assets.limit) : 0;
				this.rundownsLimit = settings && settings.subscription && settings.subscription.rundowns && settings.subscription.rundowns.limit ? duplicateVar(settings.subscription.rundowns.limit) : 0;
				this.addingUserLimit = settings && settings.subscription && settings.subscription.adding_user && settings.subscription.adding_user.limit ? duplicateVar(settings.subscription.adding_user.limit) : 0;
				this.storageLimit = settings && settings.subscription && settings.subscription.storage && settings.subscription.storage.limit ? duplicateVar(settings.subscription.storage.limit) : 0;
				// additional limit
				this.displayOutputAddLimit = settings && settings.additional && settings.additional.display_outputs ? duplicateVar(settings.additional.display_outputs) : 0;
				this.assetsAddLimit = settings && settings.additional && settings.additional.assets ? duplicateVar(settings.additional.assets) : 0;
				this.rundownsAddLimit = settings && settings.additional && settings.additional.rundowns ? duplicateVar(settings.additional.rundowns) : 0;
				this.addingUserAddLimit = settings && settings.additional && settings.additional.adding_user ? duplicateVar(settings.additional.adding_user) : 0;
				this.storageAddLimit = settings && settings.additional && settings.additional.storage ? duplicateVar(settings.additional.storage) : 0;
			}
		},
		close() {
			this.$emit('close');
		},
		insertItem(item) {
			this.data.settings = item.settings;
			this.initData();
		},
		closeModalFeature() {
			this.$emit('resetNewPackage');
			this.isFeatureFormVisible = false;
		},
		editItem(item, totalLimitData, oriLimit) {
			const data = {
				userId: this.data.id,
				name: item,
				totalLimit: totalLimitData,
				originalLimit: oriLimit,
			};
			this.selected = data;
			this.isFeatureFormVisible = true;
		},
	},
	computed: {
	},
	created() {
		this.initData();
	},
};
</script>
